import * as types from './actionTypes';

export const toggleSidebar = (event) => (dispatch) => {
  event.preventDefault();

  return dispatch({ type: types.TOGGLE_SIDEBAR });
};
